module.exports = __webpack_public_path__ + "img/logo-inove.ef88bfe9.png";